module.exports = __webpack_public_path__ + "static/media/001-Ueberzeugen_ID_32.d1925a26.mp3";